export default __webpack_public_path__ + "static/media/predection.bcf223cd.svg";